<template>
  <ul :class="_class">
    <slot />
  </ul>
</template>

<script>
const name = 'ten-dropdown-menu';
export default {
  name,
  props: {
    align: {
      type: String,
      validate(v) {
        return ['left', 'right', 'center'].indexOf(v) > -1;
      },
    },
  },
  computed: {
    _class() {
      return [
        'ten-dropdown-menu',
        'ten-dropdown__content',
        `ten-dropdown__content--align-${this.align}`,
        `ten-dropdown-menu--align-${this.align}`,
      ];
    },
  },
};
</script>
